module.exports = __webpack_public_path__ + "img/trip(14).7a48ed65.webp";